// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"627":"aa5b272c","714":"f151ad5c","858":"e604c2a3","925":"0c66780c","934":"efcfba4a"}[chunkId] + ".chunk.js";
};